// @flow
import * as types from './mutation-types'
import type { TlsProductState } from './index'
import type { TlsProductsPage } from '../../../types/tls-products-page'

export default {
  [types.SET_PRODUCTS_PAGE]: (state: TlsProductState, value: TlsProductsPage): void => {
    state.productsPage = value
  },
  [types.SET_PAGE_SIZE]: (state: TlsProductState, number: number): void => {
    state.pageSize = number
    if (state.productsPage) {
      let noPages = Math.ceil(state.productsPage.count / number)
      if (state.pageNumber >= noPages) {
        state.pageNumber = noPages - 1
      }
    }
  },
  [types.SET_PAGE_NUMBER]: (state: TlsProductState, number: number): void => {
    state.pageNumber = number
  },
  [types.SET_ORDER_BY]: (state: TlsProductState, orderBy: ?string): void => {
    state.orderBy = orderBy
  },
  [types.SET_ORDER_DIRECTION]: (state: TlsProductState, orderDirection: ?string): void => {
    state.orderDirection = orderDirection
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/tls-product/mutations.js